module.exports = __webpack_public_path__ + "static/vinicius-amnx-amano-7uIdUtSbb7w-unsplash-fd40db4ede93c79af0d2e64aea01da0a.png";